import { render, staticRenderFns } from "./betSingleStatus.vue?vue&type=template&id=16342a5e&lang=pug&"
import script from "./betSingleStatus.vue?vue&type=script&lang=js&"
export * from "./betSingleStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports